import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Image from "next/image";
import Link from "next/link";
import GNBAuthButtons from "../GNBAuthButtons";
import GNBLogo from "../GNBLogo";
import GNBMenuButtons from "../GNBMenuButtons";
import GNBSearchBox from "../GNBSearchBox";
import GNBUserDropdown from "../GNBUserDropdown";
import GNBUserTypeToggle from "../GNBUserTypeToggle";
const DesktopNav = (param)=>{
    let { homeType , onToggle , isLoggedIn , gnbBanner  } = param;
    return /*#__PURE__*/ _jsx("nav", {
        className: "hidden h-[72px] px-6 lg:block",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "mx-auto flex h-full max-w-[1200px] items-center justify-between",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-6",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center gap-4",
                            children: [
                                /*#__PURE__*/ _jsx(GNBLogo, {
                                    variant: "desktop"
                                }),
                                /*#__PURE__*/ _jsx(GNBUserTypeToggle, {
                                    value: homeType,
                                    onChange: onToggle,
                                    layoutIdPrefix: "desktop"
                                })
                            ]
                        }),
                        (gnbBanner === null || gnbBanner === void 0 ? void 0 : gnbBanner.imageUrl) && /*#__PURE__*/ _jsx(Link, {
                            href: (gnbBanner === null || gnbBanner === void 0 ? void 0 : gnbBanner.link) || "",
                            className: "h-[40px] w-[140px]",
                            children: /*#__PURE__*/ _jsx(Image, {
                                src: gnbBanner.imageUrl,
                                alt: gnbBanner.imageUrl,
                                width: 140,
                                height: 40
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-5",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex flex-1 justify-end",
                            children: /*#__PURE__*/ _jsx(GNBSearchBox, {})
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex items-center gap-1",
                            children: isLoggedIn ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(GNBMenuButtons, {}),
                                    /*#__PURE__*/ _jsx(GNBUserDropdown, {})
                                ]
                            }) : /*#__PURE__*/ _jsx(GNBAuthButtons, {})
                        })
                    ]
                })
            ]
        })
    });
};
export default DesktopNav;
